import React, { useEffect, useState } from "react";
import TableForPosition from "./components/tableForPosition";
import './index.css'
import { useSelector } from "react-redux";
import axios from "axios";
import { compareTeams } from "./utils/orderTeams";
import { useGetTeamsFromGroups } from "./hooks/useGetTeamsFromGroups";
const TablePositionTeams = ()=>{
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    const [teamsPlayOff, setTeamsPlayOff] = useState({
        bestTwos:[],
        bestThrirds:[],
        bestFour:[]
    })
    const allTeamsPlayOff = [...teamsPlayOff['bestThrirds'], teamsPlayOff['bestFour'].sort(compareTeams)?.[0]]
    const orderAllPlayOffTeams= allTeamsPlayOff?.sort(compareTeams).slice(0,16)

     const { allTeamsByGroup } =  useGetTeamsFromGroups({tournamnetId: selectedTournament._id})

    useEffect(()=>{
        if(Object?.values(allTeamsByGroup)?.length <= 0) return
           Object?.values(allTeamsByGroup)?.forEach(grupo =>{
            setTeamsPlayOff(prev => ({...prev,
                 'bestThrirds': [...prev['bestThrirds'], ...grupo.slice(0,3)],
                 'bestFour': [...prev['bestFour'], ...grupo.slice(3,4)]
                }))
        
    })

    },[Object?.values(allTeamsByGroup)?.length])



    return(<div className="talachaapp-table">
        <div className="talachaapp-container">
        {
            Object.values(allTeamsByGroup)?.map(grupo => <TableForPosition name={grupo?.[0]?.grupo}  infoGroup={grupo} />)
        }
        { (
            <TableForPosition name={'Clasificados'} infoGroup={orderAllPlayOffTeams} />
        )
            
        }

        </div>


    </div>)
}

export default TablePositionTeams;